import { type OperationId } from "@gen/app-access-config";
import { type IAdminTransaction } from "@gen/app-query";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { SubmitComplaintAction, SubmitOrderIssueAction } from "./actions";
import { CancelTransactionAction } from "./actions/CancelTransactionAction";
import {
  ConfirmF2fDelivery,
  ConfirmOnlineDelivery,
} from "./actions/ConfirmDeliveryAction";
import { ConfirmF2fHandoverAction } from "./actions/ConfirmF2fHandoverAction";
import { RefundAction } from "./actions/RefundAction";
import { RefundAfterFundsReleasedAction } from "./actions/RefundAfterFundsReleasedAction";

interface BuyerActionsSectionProps {
  canExecuteForStatus: (operationId: OperationId) => boolean;
  isF2f?: boolean;
  transactionData: IAdminTransaction;
}

export function BuyerActionsSection({
  canExecuteForStatus,
  isF2f,
  transactionData,
}: BuyerActionsSectionProps) {
  const userTransactionRole = "buyer";
  const transactionId = transactionData.id;
  return (
    <Stack
      spacing={5}
      sx={{
        pt: 5,
      }}
    >
      <Typography variant="h6DashedDivider" gutterBottom>
        Actions
      </Typography>
      {!isF2f && (
        <ConfirmOnlineDelivery
          transactionId={transactionId}
          canExecuteForStatus={canExecuteForStatus}
        />
      )}
      {isF2f && (
        <ConfirmF2fDelivery
          transactionId={transactionId}
          canExecuteForStatus={canExecuteForStatus}
        />
      )}
      <SubmitOrderIssueAction
        isF2f={isF2f}
        canExecuteForStatus={canExecuteForStatus}
        transactionId={transactionId}
      />
      <SubmitComplaintAction
        isF2f={isF2f}
        canExecuteForStatus={canExecuteForStatus}
        transactionId={transactionId}
      />
      {isF2f && transactionData.contains_shipping !== true && (
        <ConfirmF2fHandoverAction
          transactionId={transactionData.id}
          canExecuteForStatus={canExecuteForStatus}
          userTransactionRole={userTransactionRole}
        />
      )}
      <RefundAction
        canExecuteForStatus={canExecuteForStatus}
        userTransactionRole={userTransactionRole}
        transactionData={transactionData}
        isF2f={isF2f}
      />
      {isF2f && (
        <RefundAfterFundsReleasedAction
          canExecuteForStatus={canExecuteForStatus}
          transactionData={transactionData}
        />
      )}
      <CancelTransactionAction
        transactionId={transactionData.id}
        canExecuteForStatus={canExecuteForStatus}
        userTransactionRole={userTransactionRole}
        isF2f
      />
    </Stack>
  );
}
